import React from 'react';

import { useState, useEffect } from 'react';


import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';



export default function DemanderClotureContent({ onChange, action })
{
    const [clotureDemande, setClotureDemande] = useState('');

    useEffect(() => {


        const getActionData = () => {

            if (clotureDemande === '') {
                return null;
            }

            let actionData =
            {
                code: action.code,
                details: []
            };


            actionData.details.push({
                code: ReclamationActionDetailCodes.Memo,
                type: ReclamationActionDetailType.Texte,
                libelle: "Demande",
                position: actionData.details.length,
                valeurString: clotureDemande
            });

            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, clotureDemande]);


    return (
        <DialogContent>

            <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
            <Typography variant="body2" gutterBottom>{`Demander la clôture du litige à l'ACC (émetteur du dossier)`}</Typography>

            <TextField 
                label={"Demande de clôture"}
                value={clotureDemande} 
                onChange={e => setClotureDemande(e.target.value)} 
                variant={"filled"}
                fullWidth
                multiline 
            />


        </DialogContent>
    );

}

